import React, { Component } from "react";
import "./App.css";
import Controller from "./components/Controller";

class App extends Component {
  render() {
    return (
      <div>
        <Controller />
      </div>
    );
  }
}

export default App;
